// extracted by mini-css-extract-plugin
export default {"statsContainer":"styles_statsContainer__gW3t7","resultsStats":"styles_resultsStats__5zHQi"};